import chalk from "chalk";

import { writeFileAsync } from "../FsUtils";

import { ILogger } from "./ILogger";

export class Logger implements ILogger {
    private readonly logLines: string[];
    private readonly prefix?: string;
    private verboseLevel = 0;
    private readonly noSaveLogs: boolean;

    public constructor(prefix?: string, logLines?: string[], noSaveLogs = false) {
        this.prefix = prefix;
        this.logLines = logLines || [];
        this.noSaveLogs = noSaveLogs;
    }

    private pushLogLine(message: string) {
        // fix memory leak
        if (this.noSaveLogs) {
            return;
        }

        this.logLines.push(message);
    }

    public log(message: string): void {
        this.pushLogLine(message);
        // eslint-disable-next-line no-console
        console.log(this.getPrefixedMessage(message));
    }

    public warning(message: string): void {
        this.pushLogLine(message);
        // eslint-disable-next-line no-console
        console.log(this.getPrefixedMessage(chalk.yellowBright(message)));
    }

    public verbose(message: string): void {
        const messageToOutput = this.getPrefixedMessage(message);
        if (this.verboseLevel >= 1) {
            // eslint-disable-next-line no-console
            console.log(messageToOutput);
            this.pushLogLine(messageToOutput);
        }
    }

    public async flushFullLogIntoFile(fileName: string): Promise<void> {
        await writeFileAsync(fileName, this.logLines.join("\n"), "utf8");
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public error(message: any | string | Error): void {
        this.pushLogLine(`${message}`);
        // eslint-disable-next-line no-console
        console.log(this.getPrefixedMessage(chalk.redBright(message)));
    }

    public withPrefix(prefix: string): ILogger {
        let result;
        if (this.prefix == undefined) {
            result = new Logger(prefix, this.logLines);
        } else {
            result = new Logger(this.prefix + ":" + prefix, this.logLines);
        }
        result.setConsoleLoggingVerbosity(this.verboseLevel);
        return result;
    }

    public setConsoleLoggingVerbosity(verboseLevel: number): void {
        this.verboseLevel = verboseLevel;
    }

    private getPrefixedMessage(message: string | Error): string {
        const messageString = `${message}`;
        if (this.prefix == undefined) {
            return messageString;
        }
        const prefixText = chalk.gray(`[${this.prefix}]`);

        return messageString
            .split("\n")
            .map(line => `${prefixText} ${line}`)
            .join("\n");
    }
}
